import { render } from "./CreateCrossCountry.vue?vue&type=template&id=e4c92880"
import script from "./CreateCrossCountry.vue?vue&type=script&lang=js"
export * from "./CreateCrossCountry.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__